import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";


import InputDate from "../../helpers/InputDate";
import InputTime from "../../helpers/InputTime";
import InputText from "../../helpers/InputText";
import InputSearchKid from "../../helpers/InputSearchKid";
import InputCombo from "../../helpers/InputCombo";
import InputSearchEmp from "../../helpers/InputSearchEmp";
import InputDateMulti from "../../helpers/InputDateMulti";



function EatNew(props)
{


    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    
    const [view, setView] = useState('btn');

    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [row, setRow] = useState({
        dzien:  "",
        sniadanie: "0",
        obiad: "0",
        podwieczorek: "0",
        inne: '0',
        informacje_dodatkowe: '',
        px_group_id: '',          
    });



    const valChangeListener = (filedName, val, correct, msg) => {

        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);     
        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }  

    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }

    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }


    const empSelected = (id) => {

 

        setRow( {...row, ['px_group_id']:id  } );
    }



    const saveData = (e) => {


 

        if(!valChecker(row))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }

    

        if(  (row.px_group_id == undefined || row.px_group_id =='' || row.px_group_id < 1)   && props.userData.type == "DYREKTOR" )
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong ,  "Nie wybrano pracownika" ,  "ok"  ,null); 
            return; 
        }

        if(row.dzien == undefined || row.dzien == null || row.dzien.length < 3 )
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong ,  "Podaj dzień" ,  "ok"  ,null); 
                return; 
            }



 
        e.target.innerHTML = "czekaj...";

 
        props.mainView.setProgress(-2);

        var req =  row;


        fetch( Config.url + '/rest_v1_emps,eat_add', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    changeView();

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Pozycja została dodana" , "ok" , null);    
                       props.onSuccess();                      
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;

    }



    const changeView = () => {

    setRow({
        dzien:  "",
        sniadanie: "0",
        obiad: "0",
        podwieczorek: "0",
        inne: '0',
        informacje_dodatkowe: '',
        px_group_id: '', 
    });
        
        if(view == 'btn') {setView("dlg"); }  else setView('btn');
    }     


    var opType = [
        {
            v:"0",
            title: 'Nie'
        },
        {
            v:"1",
            title: 'Tak'
        },        
    ];
 


    if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setView('btn');
        }


        console.log("XXXXX", props.userData);
    var dlg_view =  (

            <div className="dlg_window dlg_type_x shadowx">

                    <div className="dlg_title">
                        Nowe zamówienie
                    </div>


                    <div className="dlg_content_x">


                                    <div className="form_tab">

                                        {
                                            props.userData.type == "DYREKTOR" &&
                                            <Fragment>

                                                    <div className="form_control">
                                                        <div className="fieldName">Pracownik</div>
                                                        <InputSearchEmp  mainView={props.mainView} userData={props.userData}   err={errTab} empSelected={empSelected} valChange={valChangeListener} goNext={goNextNew} name="fraza" placeholder={"Pracownik: "} me="0" className=' w250 ' req='1' firstUp="1" />
                                                    </div>

                                            </Fragment>
                                        }
                                        

                                       
  
                                        <div className="form_control">
                                            <div className="fieldName">Dzień</div>
                                            <InputDateMulti   userData={props.userData} value={row.dzien} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="dzien" placeholder={"Dzień: "} className=' w150 ' req='1' firstUp="1" />
                                        </div>

                                     
                                        

                                        <div className="form_split"></div>
                                

                                        <div className="form_control">
                                            <div className="fieldName">Śniadanie*</div>
                                            <InputCombo items={opType}   userData={props.userData} value={row.sniadanie} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="sniadanie" placeholder={""} className='   ' req='0' firstUp="1" />
                                        </div>

                                        <div className="form_control">
                                            <div className="fieldName">Obiad*</div>
                                            <InputCombo items={opType}   userData={props.userData} value={row.obiad} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="obiad" placeholder={""} className='   ' req='0' firstUp="1" />
                                        </div>

                                        <div className="form_control">
                                            <div className="fieldName">Podwieczorek*</div>
                                            <InputCombo items={opType}   userData={props.userData} value={row.podwieczorek} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="podwieczorek" placeholder={""} className='   ' req='0' firstUp="1" />
                                        </div>


                                        <div className="form_control">
                                            <div className="fieldName">Inne*</div>
                                            <InputCombo items={opType}   userData={props.userData} value={row.inne} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="inne" placeholder={""} className='   ' req='0' firstUp="1" />
                                        </div>


                                        <div className="form_split"></div>


                                        <div className="form_control">
                                            <div className="fieldName">Informacje dodatkowe*</div>
                                            <InputText   userData={props.userData} value={row.informacje_dodatkowe} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="informacje_dodatkowe" placeholder={""} className=' w300 ' req='0' firstUp="1" />
                                        </div>


                                        <div className="form_split"></div>

                                        <div className="form_control">                                            
                                            <div className="btn" onClick={saveData}>dodaj</div>
                                            &nbsp; &nbsp;
                                            <div className="btn" onClick={changeView}>anuluj</div>
                                        </div>

                                        <br/>&nbsp;
                                        </div>

                    </div>

                
            </div>
    );

    if(view == 'btn') dlg_view = null;


    return  <div className="inline_block">
                <div className="btn"    onClick={changeView} >dodaj zamówienie</div> 
                {dlg_view} 
           </div>
}


export default EatNew;